import { useMemo } from 'react';
import { isStaffRole } from 'shared';
import { useListUsers } from '@/hooks/useAuth';

export interface StaffOption {
  id: number;
  name: string;
}

/**
 * Staff who can own an activity or run a session: every active member of
 * staff. Any of them may run any session, whoever owns the activity.
 */
export function useStaffOptions(): { options: StaffOption[]; isLoading: boolean } {
  const { data, isLoading } = useListUsers(100, 0);

  const options = useMemo(
    () =>
      (data?.users ?? [])
        .filter((u) => isStaffRole(u.role) && u.status === 'active')
        .map((u) => ({ id: u.id, name: u.name || u.email }))
        .sort((a, b) => a.name.localeCompare(b.name, 'pt-PT')),
    [data],
  );

  return { options, isLoading };
}
